var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavGroups',{attrs:{"items":_vm.items,"access":_vm.access}})
}
var staticRenderFns = []

export { render, staticRenderFns }